import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Renderdevice from "./renderpaylist";

//import {getdevice,getfacesite,getfacegroup} from '../../services/facescan';
import {
  GetZone,
  getCarPaylist,
  GetYear,
  Getbill,
  GetSlip,
  deleteSlip,
} from "../../services/car";
import PrivilegeContext from "../context/privilege";
import BranchContext from "../context/branch";
import Select from "../common/selectcustom";
import Input from "../common/inputfunction";
import Modalbill from "./billdetails";
import ModalSlip from "./slipdetial";
import Modalcarpack from "./../carpark/modalcarpack";

import { toast } from "react-toastify";

import ScrollToTop from "../common/ScrollToTop";

const CarparkPay = (props) => {
  const { currentBranch } = useContext(BranchContext);
  const { menuItems } = useContext(PrivilegeContext);

  const [search, setsearch] = useState("");
  const [name, setname] = useState("");
  const [lastupdate, setlastupdate] = useState(new Date());
  const [groupid, setgroupid] = useState(0);
  const [month, setmonth] = useState(0);
  const [id, setid] = useState(0);


  const [yearid, setyearid] = useState(new Date().getUTCFullYear());
  //const [value, setValue] = useState([1]);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(0);
  const [paylist, setpaylist] = useState([]);
  const [billlist, setbilllist] = useState([]);
  const [sliplist, setsliplist] = useState([]);
  const [grouplist, setgrouplist] = useState([]);
  const [yearlist, setyearlist] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const [isOpenSlip, setisOpenSlip] = useState(false);
  const [isOpencar, setisOpencar] = useState(true);
  const [messageerror, setmessageerror] = useState("");
  const [messagedelete, setmessagedelete] = useState("");
  const [header, setheader] = useState("");
  const [showonscroll, setshowonscroll] = useState(false);
  const [onprocess, setonprocess] = useState(false);

  useEffect(() => {
    if (!currentBranch || !month || !id) return;
    if (!isOpenSlip) return;
    if (!menuItems) return;
    const loadData = async () => {
      const { data: result } = await GetSlip(yearid, month, id);
      if (result.status === "success") {
        setsliplist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, yearid, month, id, isOpenSlip, menuItems]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await GetYear();
      if (result.status === "success") {
        setyearlist(result.data.list);
        //setvload(true)
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch || !month || !id) return;
    if (!isOpen) return;

    const loadData = async () => {
      // console.log(yearid,month,id)

      const { data: result } = await Getbill(yearid, month, id);
      if (result.status === "success") {
        setbilllist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, yearid, month, id, isOpen]);

  const handleCanclecar = () => {
    setisOpencar(false);
  };

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await GetZone();
      if (result.status === "success") {
        setgrouplist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!menuItems) return;
    if (!pageSize) return;

    setpaylist([]);
  }, [
    currentBranch,
    yearid,
    search,
    groupid,
    pageSize,
    lastupdate,
    showonscroll,
    menuItems,
  ]);

  useEffect(() => {
    if (!currentBranch) return;

    if (onprocess) return;
    if (!pageSize || !pageNumber || !yearid) return;
    if (!menuItems) return;
    if (menuItems.length === 0) return;
    setLoading(true);
    setError(false);
    // setshowprogress(true)
    const loadData = async () => {
      const { data: result } = await getCarPaylist(
        groupid,
        yearid,
        search,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        setTotal(result.data.total);
        //  setshowprogress(false)
        setpaylist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      } else if (
        result.status === "error" &&
        result.message === "invalid token"
      ) {
        const urlGoBack = "logout";
        setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };
    loadData();
  }, [
    currentBranch,
    yearid,
    search,
    groupid,
    pageSize,
    pageNumber,
    showonscroll,
    lastupdate,
    onprocess,
    menuItems,
  ]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handlegroupChange = (event) => {
    setgroupid(event.currentTarget.value);
    setsearch(name);
    setPageNumber(1);
  };

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);
    setsearch(name);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setPageNumber(1);
      setsearch(name);
    }
  };

  const doSubmitDeleteSlip = async (id) => {
    setonprocess(true);
    const doc = { id: id };
    const { data: result } = await deleteSlip(doc);

    if (result.status === "success") {
      toast.success("ลบรายการ เสร็จเรียบร้อย");
      setonprocess(false);
      setlastupdate(new Date());
      setisOpenSlip(false);
    } else {
      toast.error(result.message);
      setmessagedelete(result.message);
    }
  };

  const handleOnClick = (id, action, status) => {
    if (status === 1) {
      setmonth(action);
      setid(id);
      setisOpenSlip(true);
    } else {
      setmonth(action);
      setid(id);
      setisOpen(true);
    }
  };

  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };

  const handlemodalTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleSearchClick = () => {
    setPageNumber(1);
    setsearch(name);
  };

  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };

  const handleCancleSubmit = () => {
    setisOpen(false);
  };
  const handleCancle = () => {
    setisOpenSlip(false);
  };
  const handleConfirmSubmit = () => {
    setlastupdate(new Date());
    setisOpen(false);
  };
  const handlemodalSlipTextchange = (event) => {};
  const handelonClickDelete = (id) => {
    doSubmitDeleteSlip(id);
  };

  return (
    <>
      <Modalbill
        isOpen={isOpen}
        button1="Save"
        onCancel={handleCancleSubmit}
        onChange={handlemodalTextchange}
        onconfirm={handleConfirmSubmit}
        list={billlist}
        header={header}
        mount={month}
        year={yearid}
        id={id}
        error={messageerror}
      />
      <ModalSlip
        isOpen={isOpenSlip}
        onCancel={handleCancle}
        onChange={handlemodalSlipTextchange}
        list={sliplist}
        onDelete={handelonClickDelete}
        error={messagedelete}
      />
      <Modalcarpack 
      isOpen={isOpencar} 
      onCancel={handleCanclecar} />

      <div className="container">
        <div className="row">
          <div className="col-lg-6  col-sm-10 col-xs-12">
           
              <Input
                name="name"
                value={name}
                label="ค้นหา"
                placeholder="ระบุล๊อค /ชื่อ สกุล"
                onChange={handleTextchange}
                onClick={handleSearchClick}
                onKeyPress={handleKeyPress}
                search="ค้นหา"
              />
        
          </div>
          <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">
              <Select
                label="ปี"
                data={yearlist}
                value={yearid}
                textProperty="name"
                valueProperty="_id"
                onChange={handleyearChange}
              />
            </div>
          </div>
          <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">
              <Select
                label="Zone"
                data={grouplist}
                value={groupid}
                textProperty="name"
                valueProperty="_id"
                onChange={handlegroupChange}
              />
            </div>
          </div>
        </div>
        {/* <Header onChange={handleChange} handleDateChange={handleDateChange} /> */}
      </div>

      <div className="container">
        <div className="row my-4">
          <div className="col-lg-4  col-sm-6 col-xs-12">
            <span className="text-success">
              แสดงข้อมูล {paylist ? paylist.length : 0} / {total} รายการ
            </span>
          </div>
          <div className="col-lg-6  col-sm-10 col-xs-12">
            <span>ชำระเงินภายในวันที่ 5 ของเดือน</span>
            <span
              className="badge rounded-pill bg-danger m-1"
              style={{ fontSize: "14px" }}
            >
              เลขที่บัญชี 849-262-1737 SCB
            </span>
          </div>
        </div>
      </div>

      {/* { showprogress && <ProgressBar bgcolor={"#6a1b9a"} completed={completed} />} */}
      {<ScrollToTop onClick={scrollToTop} />}

      <Renderdevice
        list={paylist}
        handleOnClick={handleOnClick}
        error={error}
        lastBookElementRef={lastBookElementRef}
      />
    </>
  );
};

export default CarparkPay;
